import React from 'react';

interface ConfirmDeleteModalProps {
    projectName: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
    projectName,
    onCancel,
    onConfirm
}) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={ onCancel }>
            <div className="bg-card rounded-xl shadow-lg w-full max-w-sm p-6" onClick={ (e) => e.stopPropagation() }>
                <h2 className="text-lg font-semibold text-card-foreground">Delete Project</h2>
                <p className="text-sm text-muted-foreground mt-2">
                    Are you sure you want to delete <span className="font-medium">{ projectName }</span>? This action cannot be undone.
                </p>

                <div className="mt-6 flex justify-end gap-2">
                    <button
                        onClick={ onCancel }
                        className="px-4 py-1.5 text-sm border border-border rounded-md text-card-foreground hover:bg-accent transition cursor-pointer"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={ onConfirm }
                        className="px-4 py-1.5 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition cursor-pointer"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}; 